export default {
  loading: "Cargando puntos...",
  errorLoad: "No se pudieron cargar los puntos",
  title: "Mis puntos",
  description: "Puntos obtenidos por tickets de restaurante subidos",
  currentBalance: "Saldo actual",
  pointsLabel: "puntos",
  recentTitle: "Movimientos recientes",
  emptyTitle: "Aún no hay movimientos de puntos",
  emptyDescription:
    "Suba un ticket de restaurante para ganar sus primeros puntos",
} as const;
